/**
 * Cor do swatch (usado no carrinho, por linha de item): CorHex do produto (API) →
 * fallback por nome de cor conhecido.
 * @param {string} [corHexDirect] — corHex do SKU (item do carrinho)
 */
export function getPreviewColorHex(colorName, corHexDirect) {
  const direct = (corHexDirect || "").trim();
  if (direct) return direct;
  const key = (colorName || "").trim();
  if (!key) return "#cbd5e1";
  return FALLBACK_COLOR_HEX[key] || "#94a3b8";
}

const FALLBACK_COLOR_HEX = {
  Branco: "#FFFFFF",
  Bianco: "#FFFFFF",
  Verde: "#15803d",
  Marinho: "#1e3a5f",
  Bege: "#F5F5DC",
  Cinza: "#9ca3af",
  Azul: "#2563eb",
};
